import { Create, SimpleForm } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import SaveForm from "./SaveForm";

const CreateCampaigns = () => {
  return (
    <Create
      title="Създаване на кампания"
      actions={<BackButtonToolbar />}
      transform={data => {
        const { examIds, ...rest } = data;

        return {
          ...rest,

          exams:
            data.exams?.map(exam => ({
              ...exam,

              slot: {
                ...exam.slot,

                date: exam.slot?.date?.split("T")[0] || null,
                time: exam.slot?.time?.split("T")[1] || null,
              },
            })) || [],
        };
      }}
    >
      <SimpleForm>
        <SaveForm />
      </SimpleForm>
    </Create>
  );
};

export default CreateCampaigns;
